<template>
    <div @click="visible=true">
        <a-select size="small" mode="tags" :token-separators="[',']" :open="false" v-model="checkedList" @change="onChange" style="width: 100%;">
            <a-select-option v-for="item in staffs" :key="item.id">
                {{ item.name }}
            </a-select-option>
        </a-select>
        <a-modal v-model="visible" @ok="handleOk" :footer="null" :width="600">
            <div class="flex" style="height: 400px;">
                <div class="flex-width flex-column">
                    <a-input-search placeholder="搜索员工" v-model="search" size="small" />
                    <div class="flex-height">
                        <a-tabs default-active-key="1" size="small" class="h100">
                            <a-tab-pane key="1" tab="按字母">
                                <div style="height: 300px;" class="scroll">
                                    <a-checkbox-group @change="onChange" size="small" class="w100" v-model="checkedList">
                                        <div v-for="item in staffList" :key="item.id" class="flex items-center w100">
                                            <a-checkbox :value="item.id" size="small">
                                                <span class="fs12">{{ item.name || item.username }}</span>
                                            </a-checkbox>
                                            <!-- <a-checkbox v-if="page_type==1&&item.company==2&&item.id=='38'" :value="item.id" size="small" disabled>
                                                <span class="fs12">{{ item.name || item.username }}</span>
                                            </a-checkbox>
                                            <a-checkbox v-else :value="item.id" size="small">
                                                <span class="fs12">{{ item.name || item.username }}</span>
                                            </a-checkbox> -->
                                            <div class="fs12 flex-width flex-reverse">
                                                <div class="pr10 pl10" style="background-color: #f2f2f2; color: #9c9c9c;">
                                                    {{ item.dep_name }}
                                                </div>
                                            </div>
                                        </div>
                                    </a-checkbox-group>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="2" tab="按部门">
                                <div style="height: 300px;" class="scroll">
                                    <a-tree
                                        size="small"
                                        v-model="checkedList"
                                        checkable
                                        :expanded-keys="expandedKeys"
                                        :auto-expand-parent="autoExpandParent"
                                        :selected-keys="selectedKeys"
                                        :tree-data="depData"
                                        @expand="onExpand"
                                        @select="onSelect"
                                        @check="onCheck"
                                    />
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="3" tab="收藏夹">
                                <div style="height: 300px;" class="scroll">
                                    <a-tree
                                        size="small"
                                        v-model="checkedList"
                                        checkable
                                        :expanded-keys="expandedKeys"
                                        :auto-expand-parent="autoExpandParent"
                                        :selected-keys="selectedKeys"
                                        :tree-data="favoriteData"
                                        @expand="onExpand"
                                        @select="onSelect"
                                        @check="onCheck"
                                    >
                                        <!-- <template #title="{ key: treeKey, title }">
                                            <a-dropdown :trigger="['contextmenu']">
                                                <span>{{ title }}</span>
                                                <template #overlay>
                                                <a-menu @click="({ key: menuKey }) => onContextMenuClick(treeKey, menuKey)">
                                                    <a-menu-item key="1">1st menu item</a-menu-item>
                                                    <a-menu-item key="2">2nd menu item</a-menu-item>
                                                    <a-menu-item key="3">3rd menu item</a-menu-item>
                                                </a-menu>
                                                </template>
                                            </a-dropdown>
                                        </template> -->
                                    </a-tree>
                                    <div>
                                        <a-button type="link" icon="plus" @click="addGroup">
                                            点击添加
                                        </a-button>   
                                    </div>
                                   
                                </div>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                </div>
                <div class="ml10 mr10" style="background-color: #e8e8e8; width: 1px; height: 100%;"></div>
                <div style="width: 200px;" class="h100 flex-column">
                    <div>
                        已选中 {{ selectedPerson.length }} 人
                    </div>
                    <div class="flex-height scroll mt10">
                        <div v-for="item in selectedPerson" :key="item.id" class="mb5">
                            <a-tag closable @close="closePerson(item.id)">{{item.name || item.username}}</a-tag>
                            <!-- <a-tag v-if="page_type==1&&item.company==2&&item.id=='38'">{{item.name || item.username}}</a-tag>
                            <a-tag v-else closable @close="closePerson(item.id)">{{item.name || item.username}}</a-tag> -->
                        </div>
                    </div>
                </div>
            </div>
        </a-modal>
        <a-modal
            title="新建同事收藏夹"
            :visible="visibleAdd"
            width="30%"
            centered
            @cancel="visibleAdd=false"
            okText="确定"
            cancelText="取消"
            @ok="addFavorite"
        >
            <div class="pr20" >
                <div>
                    <div class="mb5 flex">收藏夹名称<div style="color:red">*</div></div>
                    <a-input size="small" v-model="form.title" v-decorator="[ 'title', { rules: [{ required: true, message: '请输入收藏夹名称' }] }, ]"
                        placeholder="请输入收藏夹名称"
                    />
                </div>
                <div>
                    <div class="mb5 flex">人员<div style="color:red">*</div></div>
                    <choose-person-box-without-favorite v-model="form.persons"></choose-person-box-without-favorite>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import ChoosePersonBoxWithoutFavorite from './ChoosePersonBoxWithoutFavorite.vue'
export default {
    components:{ChoosePersonBoxWithoutFavorite},
    props:{
        // visible:{
        //     type:Boolean,
        //     default:false
        // }
    },
    data() {
        return {
            visible: false,
            staffs: [],
            treeData: [],
            treeFavoriteData: [],
            checkedList: [],
            expandedKeys: ['0'],
            autoExpandParent: true,
            checkedKeys: [],
            selectedKeys: [],
            selectedPerson: [],
            search: "",
            visibleAdd:false,
            form:{title:null, data:[], persons:[],},
            page_type:0, //0普通 1用印申请-固定审批人
        }
    },
    props: ["value"],
    watch: {
        value(n, o) {
            // console.log(n)
            if (n.length == 0) {
                this.checkedList = [];
            }
            this.checkedList = n;
        }
    },
    computed: {
        staffList() {
            if (this.search == "") {
                return this.staffs;
            } else {
                return this.staffs.filter((it) => {
                    if (it.name != null) {
                        return (it.name.indexOf(this.search) != -1) || (this.checkedList.indexOf(it.id) != -1)
                    } else {
                        return (it.username.indexOf(this.search) != -1) || (this.checkedList.indexOf(it.id) != -1)
                    }
                });
            }
        },
        depData() {
            if (this.search == "") {
                return this.treeData;
            } else {
                let children = [];
                let deps = {};
                for (let item of this.staffs) {
                    if (item.name != null) {
                        if ((item.name.indexOf(this.search) == -1) && (this.checkedList.indexOf(item.id) == -1)) {
                            continue;
                        }
                    }
                    
                    item.id = item.id.toString();
                    let dep_id = item.dep_id || 0;
                    if (dep_id == 0) {
                        children.push({
                            title: item.name,
                            key: item.id
                        })
                    } else {
                        if (deps[dep_id] == null) {
                            deps[dep_id] = {
                                title: item.dep_name,
                                // key: `d-${item.dep_id}`,
                                key: item.dep_id,
                                children: []
                            }
                            children.push(deps[dep_id])
                        }
                        if (deps[dep_id].children == null) {
                            deps[dep_id].children = [];
                        }
                        deps[dep_id].children.push({
                            title: item.name,
                            key: item.id
                        })
                    }
                }
                // for(let item of this.checkedList){
                //     let part = this.staffs.find(it=>it.id == item)
                //     if(part != null){
                //         children.push({id:part.id, title:part.name})
                //     }
                // }
                // console.log(this.checkedList)
                
                let treeData = [{
                    title: "浙江大虞建设有限公司",
                    key: "0",
                    children
                }]
                // console.log(treeData)
                return treeData;
            }
        },
        favoriteData(){
            if (this.search == "") {
                return this.treeFavoriteData;
            } else {
                let returnData = []
                for (let item of this.treeFavoriteData) {
                    // if(item.children.filter(it=>it.title.indexOf(this.search) == -1&& this.checkedList.indexOf(it.key) == -1)){
                    //     continue;
                    // }
                    let as = {data:null, key:null, children:[], title:null}
                    as.key = item.key 
                    as.id = item.id
                    as.title = item.title
                    for(let part of item.children){
                        if((part.title.indexOf(this.search) == -1)&&(this.checkedList.indexOf(part.key) == -1)){
                            continue;
                        }
                        as.children.push({key:part.key, title:part.title})
                    }
                    if(item.children.length != 0){
                        returnData.push(as)
                    }
                }
                return returnData
            }
        }
    },
    created() {
        this.getCompanyStaff();
        this.getFavoriteGroup();
    },
    methods: {
        async getCompanyStaff() {
            let rs = await this.$api.getCompanyStaff();
            if (rs.err == 0) {
                let personMap = {};
                for (let item of rs.data) {
                    personMap[item.id] = item;
                }
                let data = [];
                for (let key in personMap) {
                    data.push(personMap[key])
                }
                data.sort((a,b)=>{
                    return a.name - b.name;
                })
                this.staffs = data;
                let ca = 1
                for(let part of this.staffs){
                    if(part.name == null){
                        part.name =  part.username
                    }
                    part.key = ca
                    ca++
                }
                // console.log(this.staffs)
                let children = [];
                let deps = {};
                // deps[0] = children;
                for (let item of rs.data) {
                    item.id = item.id.toString();
                    let dep_id = item.dep_id || 0;
                    if (dep_id == 0) {
                        children.push({
                            title: item.name,
                            key: item.id
                        })
                    } else {
                        if (deps[dep_id] == null) {
                            deps[dep_id] = {
                                title: item.dep_name,
                                key: `d-${item.dep_id}`,
                                // key: item.dep_id,
                                children: []
                            }
                            children.push(deps[dep_id])
                        }
                        if (deps[dep_id].children == null) {
                            deps[dep_id].children = [];
                        }
                        deps[dep_id].children.push({
                            title: item.name,
                            key: item.id
                        })
                    }
                    
                }
                
                this.treeData = [{
                    title: "浙江大虞建设有限公司",
                    key: "0",
                    children
                }]
            }
        },
        async getFavoriteGroup(){
            let rs = await this.$api.getFavoriteGroup();
            if (rs.err == 0) {
                for(let item of rs.data){
                    let children = []
                    item.data = JSON.parse(item.data)
                    item.key = `d-${item.id}`
                    for(let part of item.data){
                        children.push({key:part.id.toString(), title:part.name})
                    }
                    item.children = children
                }
                this.treeFavoriteData = rs.data
            }
        },
        handleOk() {

        },
        onChange() {
            // if(this.page_type == 1 && this.staffs[0].company == 2){
            //     let item = this.checkedList.find(it=>it == '38')
            //     if(item == null){
            //         this.checkedList.push('38')
            //     }
            // }
            for (let i = this.checkedList.length - 1; i >= 0; i--) {
                if (this.checkedList[i].indexOf("d-") != -1) {
                    this.checkedList.splice(i, 1)
                }
            }
            this.selectedPerson = this.staffs.filter((it) => {
                return this.checkedList.indexOf(it.id) != -1
            })
            this.$emit("input", this.checkedList);
            this.$emit("change", this.checkedList);

        },

        onExpand(expandedKeys) {
            // console.log('onExpand', expandedKeys);
            this.expandedKeys = expandedKeys;
            this.autoExpandParent = false;
        },
        onCheck(checkedKeys) {
            // console.log('onCheck', checkedKeys);
            this.checkedList = checkedKeys.filter(item => (!Number.isInteger(item))&&item != '0');;
            // this.checkedList = checkedKeys;
            this.onChange();
        },
        onSelect(selectedKeys, info) {
            // console.log('onSelect', info);
            this.selectedKeys = selectedKeys;
        },
        clearSelect(){
            this.selectedPerson = []
        },
        addGroup(){
            this.visibleAdd = true
            this.form = {title:null, data:[]}
        },
        async addFavorite(){
            for(let item of this.form.persons){
                let as = {id:parseInt(item), name:""}
                let part = this.staffs.find(it=>it.id == item)
                if(part!=null){
                    as.name = part.name
                    this.form.data.push(as)
                }
            }
            let s1 = JSON.stringify(this.form)
            let rs = await this.$api.addFavorite(s1)
            if(rs.err == 0){
                this.$message.success("创建成功！")
                this.getFavoriteGroup()
                this.visibleAdd = false
            }
            // persons格式，id + name
        },
        closePerson(id){
            this.checkedList = this.checkedList.filter(it=>it!=id)
            this.onChange()
        },
        async clearType(data){
            if(data != undefined){
                await this.getCompanyStaff()
                this.search = ''
                this.page_type = data.page_type
                this.checkedList = data.data
                this.selectedPerson = this.staffs.filter((it) => {
                    return this.checkedList.indexOf(it.id) != -1
                })
                this.$forceUpdate()
            }else{
                this.search = ''
                this.checkedList = []
                this.selectedPerson = []
            }
        },
        onContextMenuClick(){

        },

    }
}
</script>

<style>
.ant-tree-title {
    font-size: 12px;
}
</style>